import { prop } from 'ramda'
import { Box } from '@mui/material'
import { useCurrentAppType } from 'hooks'

import WelcomeSectionWrapper from './components/WelcomeSectionWrapper'
import WelcomeFooter from './components/WelcomeFooter'
import WelcomeSectionHero from './components/WelcomeSectionHero'
import WelcomeSectionAbout from './components/WelcomeSectionAbout'
import WelcomeSectionCards from './components/WelcomeSectionCards'
import WelcomeSectionTools from './components/WelcomeSectionTools'
import WelcomeSectionStories from './components/WelcomeSectionStories'
import WelcomeSectionQuotes from './components/WelcomeSectionQuotes'
import WelcomeSectionResources from './components/WelcomeSectionResources'
import CTA from './components/CTA'

const Welcome = () => {
  const { isCollective, isWellpower } = useCurrentAppType()

  const welcomeWidgets = {
    about: (
      <WelcomeSectionWrapper curveBottom curveTop key="about">
        <WelcomeSectionAbout />
      </WelcomeSectionWrapper>
    ),
    cards: (
      <WelcomeSectionWrapper key="cards" toggleGrey>
        <WelcomeSectionCards />
      </WelcomeSectionWrapper>
    ),
    cta: (
      <WelcomeSectionWrapper curveBottom key="cta" toggleGrey>
        <CTA />
      </WelcomeSectionWrapper>
    ),
    hero: (
      <WelcomeSectionWrapper curveBottom key="hero">
        <WelcomeSectionHero />
      </WelcomeSectionWrapper>
    ),
    quotes: (
      <WelcomeSectionWrapper key="quotes" toggleGrey>
        <WelcomeSectionQuotes />
      </WelcomeSectionWrapper>
    ),
    resources: (
      <WelcomeSectionWrapper curveTop key="resources">
        <WelcomeSectionResources />
      </WelcomeSectionWrapper>
    ),
    stories: (
      <WelcomeSectionWrapper key="stories" toggleGrey>
        <WelcomeSectionStories />
      </WelcomeSectionWrapper>
    ),
    tools: (
      <WelcomeSectionWrapper curveBottom curveTop key="tools">
        <WelcomeSectionTools />
      </WelcomeSectionWrapper>
    )
  }

  // each app type needs a welcome page list
  const widgetList = () => {
    if (isWellpower) return ['hero', 'cta', 'cards', 'tools', 'quotes']
    if (isCollective) return ['hero', 'quotes', 'about', 'tools', 'resources']
    return ['hero', 'cards', 'tools']
  }

  return (
    <Box
      sx={{
        bgcolor: isCollective ? 'collective.dark' : 'white'
      }}
    >
      {widgetList().map(widgetName => prop(widgetName, welcomeWidgets))}
      <WelcomeFooter />
    </Box>
  )
}

export default Welcome
